export default "data:image/webp;base64,UklGRjAAAABXRUJQVlA4TCQAAAAvJ4AGACDMNgIa4fGeUJ9iwWT+fsH0CQRSHMkU9z8r5o95ZgY="